import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { PaymentPack } from "../../../Packs/PaymentModal/types";
import { PricingTypes } from "../../../../../enums/licensing/pricingTypes";
import { type LicenseConfirmationFormItem } from "../../LicenseConfirmationModalContent/LicenseConfirmationBlockV2/utils";

export interface LicenseConfirmationInfoState {
  paymentPacks?: PaymentPack[];
}

const initialState: LicenseConfirmationInfoState = {};

const licenseConfirmationInfoSlice = createSlice({
  name: "licenseConfirmationInfo",
  initialState,
  reducers: {
    updateLicensePackInfo(state: LicenseConfirmationInfoState, action: PayloadAction<LicenseConfirmationFormItem[]>) {
      const isEligiblePack = (p: LicenseConfirmationFormItem) => {
        const isPaidPurchase = p.licensesCount && p.packPricingTypeId === PricingTypes.Paid && !p.isTrial;
        const shouldRenewExpiredPaid =
          p.isAccountPackLicenseExpired && ![PricingTypes.Other, PricingTypes.Free].includes(p.packPricingTypeId);

        return isPaidPurchase || shouldRenewExpiredPaid;
      };

      state.paymentPacks = action.payload.filter(isEligiblePack).map((p) => ({
        packId: p.packId,
        packName: p.title,
        billingTerm: "Annual",
        rawPricePerUser: p.pricingSettings?.pricePerUser!,
        licensesCount: p.licensesCount,
        expirationDate: p.expirationDate,
        purchasingLicenses: p.purchasingLicenses,
        isTrial: false,
        isPurchased: true,
        isExpired: p.isAccountPackLicenseExpired,
      }));
    },

    reset() {
      return initialState;
    },
  },
});

export const { updateLicensePackInfo, reset } = licenseConfirmationInfoSlice.actions;

export default licenseConfirmationInfoSlice.reducer;
